<button
    mat-flat-button
    aria-label="mobile menu"
    (click)="openDialog()"
>
    <mat-icon class="mobile-menu">menu</mat-icon>
</button>
